<template>
  <transition name="app-dialog">
    <div class="app-dialog" :class="{ light, dense }" v-if="value">
      <div class="app-dialog-content">
        <slot />

        <button class="app-dialog-close" @click="$emit('input', false)" v-if="enableClose">
          <svg-loader src="/assets/images/icon-canvas-close.svg" inline></svg-loader>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'AppDialog',
    props: {
      value: Boolean,
      light: Boolean,
      dense: Boolean,
      enableClose: Boolean
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta';

  .app-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    background: rgba(#000, .6);
    text-align: center;
    transition: opacity .2s $transition-ease-out;

    &.light {
      background: rgba(#fff, .6);
    }

    &.dense {
      .app-dialog-content {
        margin: 0 12px;
        padding: 12px;
        box-shadow: 0 7px 8px -4px rgba(#000, .2),
                    0 12px 17px 2px rgba(#000, .14),
                    0 5px 22px 4px rgba(#000, .12);
        font-size: 14px;
        line-height: 1.3em;

        ::v-deep .button {
          margin-top: 8px;
        }
      }
    }
  }

  .app-dialog-enter,
  .app-dialog-leave-active {
    opacity: 0;

    .app-dialog-content {
      opacity: 0;
      transform: scale(.3);
    }
  }

  .app-dialog-content {
    position: relative;
    padding: 26px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 11px 15px -7px rgba(#000, .2),
                0 24px 38px 3px rgba(#000, .14),
                0 9px 46px 8px rgba(#000, .12);
    font-size: 15px;
    line-height: 1.35em;
    transition: opacity .3s $transition-ease-out,
                transform .4s $transition-ease-out;

    ::v-deep .button {
      margin-top: 20px;

      + .button {
        margin-left: 16px;
      }
    }
  }

  a {
    ::v-deep &.app-dialog-link {
      font-size: 11px;
      color: $color-red;
      text-transform: uppercase;

      &:hover {
        color: darken($color-red, 20%);
      }
    }
  }

  .app-dialog-close {
    @include clear-button;
    position: absolute;
    top: -20px;
    right: -20px;
    width: 20px;
    height: 20px;

    .svg-image {
      path:last-child {
        fill: #000;
      }
    }
  }
</style>
